import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';

import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import ResultsPage from './pages/ResultsPage';
import SalesPage from './pages/SalesPage';
import SalonPrivePage from './pages/SalonPrivePage';
import MockupC from './pages/MockupC';
import MockupD from './pages/MockupD';
import EbookPage from './pages/EbookPage';
import AppLaunchPage from './pages/AppLaunchPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import OfferDetailPage from './pages/OfferDetailPage';
import ContractPage from './pages/ContractPage';
import ConfiguratorPage from './pages/ConfiguratorPage';
import ConfiguratorWizardPage from './pages/ConfiguratorWizardPage';
import ConfiguratorFinaliserPage from './pages/ConfiguratorFinaliserPage';
import PRSNLSuccessPage from './pages/PRSNLSuccessPage';
import RecruitmentPage from './pages/RecruitmentPage';
import SetterGuidePage from './pages/SetterGuidePage';
import SetterCallScriptPage from './pages/SetterCallScriptPage';
import CloserCallScriptPage from './pages/CloserCallScriptPage';
import CRMPage from './pages/CRMPage';
import OnboardingPage from './pages/OnboardingPage';
import TeamPage from './pages/TeamPage';
import TeamAuthPage from './pages/TeamAuthPage';
import StatsPage from './pages/StatsPage';
import SabrilAdminPage from './pages/SabrilAdminPage';
import GlobalNavbar from './components/GlobalNavbar';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App min-h-screen bg-brand-black">
      <BrowserRouter>
        <ScrollToTop />
        <GlobalNavbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/diagnostic" element={<QuizPage />} />
          <Route path="/resultats/:id" element={<ResultsPage />} />
          <Route path="/prsnl" element={<SalonPrivePage />} />
          <Route path="/prsnl-mockup-c" element={<MockupC />} />
          <Route path="/prsnl-mockup-d" element={<MockupD />} />
          <Route path="/prsnl-classic" element={<SalesPage />} />
          <Route path="/app" element={<AppLaunchPage />} />
          <Route path="/prsnl/success" element={<PRSNLSuccessPage />} />
          <Route path="/ebook" element={<EbookPage />} />
          <Route path="/ebook/:accessCode" element={<EbookPage />} />
          <Route path="/offre" element={<Navigate to="/ebook" replace />} />
          <Route path="/offre/:key" element={<OfferDetailPage />} />
          <Route path="/contrat/:offer" element={<ContractPage />} />
          <Route path="/configurer" element={<ConfiguratorWizardPage />} />
          <Route path="/configurer/v1" element={<ConfiguratorPage />} />
          <Route path="/configurer/finaliser" element={<ConfiguratorFinaliserPage />} />
          <Route path="/configurateur" element={<Navigate to="/configurer" replace />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/recrutement" element={<RecruitmentPage />} />
          <Route path="/setter-guide" element={<SetterGuidePage />} />
          <Route path="/setter-call-script" element={<SetterCallScriptPage />} />
          <Route path="/closer-call-script" element={<CloserCallScriptPage />} />
          <Route path="/crm" element={<CRMPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/equipe" element={<TeamPage />} />
          <Route path="/connexion" element={<TeamAuthPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/admin/sabril" element={<SabrilAdminPage />} />
          <Route path="/admin/leads-sabril" element={<SabrilAdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
